import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Tempo relativo em pt-BR a partir de um ISO (first-seen postedAt da oferta):
 *   < 60s → "agora" · < 60min → "há Nmin" · < 24h → "há Nh" · resto → "há Nd"
 * Retorna null quando o ISO é ausente/inválido (UI deve esconder o carimbo).
 * Reusa o `now` do timer único da vitrine — sem novo setInterval.
 */
export function formatRelativeTime(nowMs: number, postedAtIso?: string): string | null {
  if (!postedAtIso) return null;
  const t = new Date(postedAtIso).getTime();
  if (Number.isNaN(t)) return null;
  const diff = nowMs - t;
  if (diff < 0) return "agora";
  const min = Math.floor(diff / 60000);
  if (min < 1) return "agora";
  if (min < 60) return `há ${min}min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `há ${h}h`;
  const d = Math.floor(h / 24);
  return `há ${d}d`;
}

/** true se a oferta foi postada nas últimas 24h (badge "🆕 NOVO"). */
export function isNewOferta(nowMs: number, postedAtIso?: string): boolean {
  if (!postedAtIso) return false;
  const t = new Date(postedAtIso).getTime();
  if (Number.isNaN(t)) return false;
  return nowMs - t < 24 * 60 * 60 * 1000;
}